import { mapMutations, mapState } from 'vuex';
import { EventBus } from '@/store/eventBus';

const PopulationBoilerplate = {
    computed: {
        ...mapState('populationEditor', [
            'fieldName',
            'fieldType',
            'fieldOptions',
            'population'
        ]),
    },

    data() {
        return {
            fieldData: [],
            namespace: 'populationEditor',
        };
    },

    mounted() {
        this.loadFieldData();
        EventBus.$on(`${this.namespace}UpdateFieldData`, (fieldData) => this.updateFieldData(fieldData));
    },

    methods: {
        ...mapMutations({
            setPopulation: 'populationEditor/setPopulation',
        }),

        updateFieldData(fieldData) {
            this.fieldData = fieldData;
            this.storeFieldData();
        },

        storeFieldData() {
            this.setPopulation(this.fieldData);
        },
    }
};

export default PopulationBoilerplate;
